export default __webpack_public_path__ + "static/media/complokCertificateBadge.e45807a4.png";